<style lang="less" scoped>
@import '../../../style/common/variable';
.kyzx{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
.national{width: 1200px;}
.first{display: flex;justify-content:space-between;width: 1200px;margin:auto;}
.second{width: 830px;margin-right: 20px;}
.third{display: flex;flex-direction: column;width: 350px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 19px;color: rgb(25, 159, 248);}
.classification{margin: 18px 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.category{margin-left: -18px;margin-top: -10px;}
.latestnews{margin-top: 48px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 3px;font-size: 18px;color: rgb(25, 159, 248);}
}
.ListZX{margin-left: -32px;margin-top: 0px;text-align: left;}
.hotnews{margin-top: 0px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: baseline;float: left;margin-left: -5px;margin-right: -2px;font-size: 19px;color: rgb(25, 159, 248);}
}
.hotNewsList{margin-left: -32px;margin-top: 0px;text-align: left;}
.reading{margin-top: -10px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.ListYD{margin-left: -32px;margin-top: 0px;text-align: left;}
.sticky{position: sticky; top: 10px;margin: 0px;display: flex;flex-direction: column;justify-content:center;}
@media screen and (max-width: @max-screen){
  .third{display: none;}
}
</style>

<template>
  <div class="kyzx">
    <National class="national"></National>
    <div class="first">
      <div class="second">
        <router-view />
      </div>
      <div class="third">
        <div class="classification">
          <i class="iconfont icon-fenlei_" />
          <span>资讯分类 / Information classification</span>
        </div>
        <Category class="category" :categoryList="categorydata" @clickCategory="goList"></Category>
        <div class="sticky">
          <div class="hotnews">
            <i class="iconfont icon-zuirehotchunse" />
            <span>热门资讯 / Hot news</span>
          </div>
          <HotNewsList class="hotNewsList" :hotNewsList="hotNewsdata" @clickHotNews="goDetails"></HotNewsList>
          <div class="reading">
            <i class="iconfont icon-tubiao303" />
            <span>推荐阅读 / Recommended reading</span>
          </div>
          <List class="ListYD" :List="readingdata" @clickListNews="goDetails"></List>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 矿业资讯 公共部分页面
 */
import National from '../assembly/National.vue'
import Category from '../assembly/Category.vue'
import List from '../assembly/List.vue'
import HotNewsList from '../assembly/HotNewsList.vue'
import arrayFun from '../method/array.js'
export default {
  components: {
    National,
    Category,
    List,
    HotNewsList
  },
  name: '',
  data()
  {
    return {
      categorydata: [], //资讯分类
      hotNewsdata: [], // 热门资讯
      readingdata: [] // 推荐阅读
    }
  },
  created()
  {
    this.getCount()
    this.getCategory()
    this.getKyzx()
  },
  methods: {
    // 通过usersql，获取矿业资讯每个类别的数量
    getCount()
    {
      let paras = {cmd: 'querySQL', _major: 99, _minor: 47,  keyno: 'kyzxtj'}
      this._A = window.post.getPost(paras)
    },
    // 获取当前在页面展示的资讯分类数据
    async getCategory()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=18'}
      let CountList = await this._A
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret.forEach(item => temp.push({catid: item.id, dispc: item.dispc}))
        let tempCatID = []
        CountList.forEach(item => tempCatID.push(item.catid))
        for (let i = 0; i < temp.length; i++)
        {
          if (tempCatID.indexOf(temp[i].catid) !== -1)
            this.categorydata.push({catid: temp[i].catid, type: temp[i].dispc, count: CountList[tempCatID.indexOf(temp[i].catid)].counts})
          else
            this.categorydata.push({catid: temp[i].catid, type: temp[i].dispc, count: 0})
        }
      })
    },
    // 从数据库获取矿业资讯页面推荐阅读及热门资讯数据
    getKyzx()
    {
      let paras6 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'addtime>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras6).then((ret) =>
      {
        this.readingdata = ret[0].data // 推荐阅读
        let temp1 = JSON.stringify(ret[0].data)
        let temp2 = JSON.parse(temp1)
        this.hotNewsdata = temp2.sort(arrayFun.compareBtoS('hits'))  // 热门资讯
      })
    },
    // 跳转到矿业资讯列表页面，并将被点击的分类名称提交到vuex
    goList(item)
    {
      let url = this.$router.resolve({path: '/KyzxList', query: {catid: item.catid, ssgj: ''}})
      window.open(url.href, '_blank')
    },
    // 跳转到矿业资讯详情页面，并将被点击的新闻的id传递到详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Kyzx.vue